import React, { ReactNode } from 'react';
import cn from 'classnames';

type HintProps = {
  id: string;
  hint?: ReactNode;
  errorText?: ReactNode;
  accessibilityProps?: any;
  hintClassName?: string;
};

export function TextFieldHint({
  id,
  hint,
  errorText,
  hintClassName
}: HintProps) {
  if (!hint && !errorText) {
    return (
      <div
        id={id}
        className={cn(
          'mt-1',
          'text-xs',
          hintClassName,
          {
            'text-red-500 dark:text-red-500': !!errorText,
            'text-blue-gray-700 dark:text-gray-400': !!hint
          },
          'animate-slide-top',
          'font-normal font-inter',
          'leading-4',
          'invisible',
          'h-4'
        )}
      >
        {''}
      </div>
    );
  }

  return (
    <div
      id={id}
      className={cn(
        'mt-1',
        'text-xs',
        hintClassName,
        {
          'text-red-600 dark:text-red-600': !!errorText,
          'text-blue-gray-700 dark:text-gray-400': !!hint
        },
        'animate-slide-top',
        'font-normal',
        'leading-4 tracking-normal text-left flex-grow-0 not-italic'
      )}
    >
      {errorText || hint}
    </div>
  );
}
